import { useState } from 'react';
import { MainSummaryTab } from './MainSummaryTab.js';
import { ClientsTab } from './ClientsTab.js';

/**
 * סקירת יועץ — two admin screens:
 *  - the MAIN summary (under "תוכן"): write it and save it as a new version
 *    (versions never change);
 *  - per client (under "עדכון לקוח"): copy a version into the client's draft,
 *    adjust it, and publish it.
 * The client sees only what was published for them, until the next publish.
 */
export function AdvisorMainCard() {
  // Bumped after a version is saved, so the screen re-reads the list.
  const [tick, setTick] = useState(0);
  return <MainSummaryTab tick={tick} onSaved={() => setTick((t) => t + 1)} />;
}

export function AdvisorClientsCard() {
  return <ClientsTab />;
}
